var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShowModel
    ? _c(
        "div",
        {
          staticClass: "maintenance-module",
          style: {
            background: _vm._.get(_vm.dataCms, "news_background_color"),
            fontWeight: "initial"
          }
        },
        [
          _c("img", {
            attrs: { src: _vm.MINIO_BUCKET_ADDRESS + "/warning.png", alt: "" }
          }),
          _vm._v(" "),
          _c("p", {
            directives: [
              {
                name: "dompurify-html",
                rawName: "v-dompurify-html",
                value: _vm._.get(_vm.dataCms, "maintenance_notice", ""),
                expression: "_.get(dataCms, 'maintenance_notice', '')"
              }
            ],
            staticClass: "tls-simple-text -color-white"
          })
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }